/* eslint-disable @typescript-eslint/naming-convention */
import moment from 'moment';

import { matchedResidenceEnum, matchedBusinessCategoryEnum } from './DtoHelper';

export function createModalkuNewFormDto(form, businessCategoryEnum) {
  let matchedCurrentResidenceOwnership;
  let matchedBusinessResidenceOwnership;
  let matchedBusinessCategory;

  try {
    matchedCurrentResidenceOwnership = matchedResidenceEnum(
      form.current_residence_ownership
    );
    matchedBusinessResidenceOwnership = matchedResidenceEnum(
      form.business_residence_ownership
    );
    matchedBusinessCategory = matchedBusinessCategoryEnum(
      form.business_category,
      businessCategoryEnum
    );
  } catch (error) {
    throw new Error(error as string);
  }

  const { is_address_same_as_ktp: isAddressSameAsKTPAddress } = form;

  return {
    form: {
      loan_type: 20,
      amount: form.pre_approved_amount,
      purpose: 3,
      tenor: form.duration,
      user: {
        fullname: form.full_name,
        member_type: 2,
        email: form.email,
        phone: `0${form.phone_number}`,
        company_name: form.business_name,
      },
      others: {
        personal_info: {
          other_phone_number:
            typeof form.other_phone_number !== 'undefined'
              ? `0${form.other_phone_number}`
              : '0',
          nik: form.nik,
          place_of_birth: form.place_of_birth,
          birth_date: form.birth_date
            ? moment(form.birth_date).format('DD/MM/YYYY')
            : form.birth_date,
          gender: form.gender,
          marital_status: form.marital_status,
          ktp_address: form.ktp_address,
          ktp_city: form.ktp_city,
          ktp_province: form.ktp_province,
          ktp_zipcode: form.ktp_zipcode,
          home_address: isAddressSameAsKTPAddress
            ? form.ktp_address
            : form.address,
          home_city: isAddressSameAsKTPAddress ? form.ktp_city : form.home_city,
          home_province: isAddressSameAsKTPAddress
            ? form.ktp_province
            : form.home_province,
          home_zipcode: isAddressSameAsKTPAddress
            ? form.ktp_zipcode
            : form.home_zipcode,
          residence_ownership: matchedCurrentResidenceOwnership,
        },
        business_info: {
          business_category: matchedBusinessCategory,
          business_address: form.business_address,
          business_city: form.business_city,
          business_province: form.business_province,
          business_zipcode: form.business_zipcode,
          business_place_ownership: matchedBusinessResidenceOwnership,
          business_type: form.business_type,
          business_start_date: `01-${form.business_start_month}-${form.business_start_year}`,
        },
        loan_purpose: form.loan_purpose,
        callback_url: '',
      },
    },
    interest_rate: form.interest_rate,
    documents: {
      ktp_data_url: form.ktp_file.code,
      npwp_data_url: form.npwp_file ? form.npwp_file.code : form.npwp_file,
      ktp_pasangan_data_url: form.ktp_spouse_file
        ? form.ktp_spouse_file.code
        : form.ktp_spouse_file,
      selfie_with_id_data_url: form.selfie_with_id_file.code,
      siup_data_url: form.siup_file ? form.siup_file.code : form.siup_file,
      foto_outlet_data_url: form.outlet_picture_file
        ? form.outlet_picture_file.code
        : form.outlet_picture_file,
      rekening_koran_1: form.bank_statement_1_file
        ? form.bank_statement_1_file.code
        : form.bank_statement_1_file,
      rekening_koran_2: form.bank_statement_2_file
        ? form.bank_statement_2_file.code
        : form.bank_statement_2_file,
      rekening_koran_3: form.bank_statement_3_file
        ? form.bank_statement_3_file.code
        : form.bank_statement_3_file,
    },
  };
}
